import { getCurrentScope, onScopeDispose } from 'vue';
import { LeadBannerPlacement, useLeadBannerTracking } from '@/entities/analytics';
import type { ProductSearch } from '@/entities/product';

export function useLeadBannerSession(productSearch: ProductSearch): void {
  const { reset } = useLeadBannerTracking();

  const unsubscribe = productSearch.on('start', () => reset(LeadBannerPlacement.Serp));

  if (getCurrentScope()) onScopeDispose(unsubscribe);
}
